import { useMutation, useQueryClient, mutationOptions } from '@tanstack/react-query';

import { updateUserPassword } from '../../api/userCredentialService';

import { userCredentialsMutationKeys } from './keys';

export const updateUserPasswordOptions = () =>
	mutationOptions({
		mutationKey: userCredentialsMutationKeys.updatePassword,
		mutationFn: ({ newEmail, newPassword, currentPassword }) =>
			updateUserPassword({
				newEmail: newEmail,
				newPassword: newPassword,
				currentPassword: currentPassword,
			}),
	});

export function useUpdateUserPassword() {
	const qc = useQueryClient();
	return useMutation(updateUserPasswordOptions(qc));
}
